import { EmptyState } from '@efdigital/ll-xceed-v2/components/application/empty-state';
import OnboardingAnswerSummary from '@efdigital/ll-xceed-v2/components/coaching/onboarding-answer-summary.gts';
import type { OnboardingAnswer } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees/coachee/about';
import type { TOC } from '@ember/component/template-only';

interface CoacheeOnboardingAnswersSignature {
  Args: {
    onboardingAnswers: OnboardingAnswer[];
  };
}

function gt(left: number, right: number): boolean {
  return left > right;
}

<template>
  {{#if @onboardingAnswers.length}}
    {{#each @onboardingAnswers as |onboardingAnswer|}}
      {{#if (gt @onboardingAnswers.length 1)}}
        <h3 class="h5 fw-bold mb-3">{{onboardingAnswer.quiz.title}}</h3>
      {{/if}}

      <OnboardingAnswerSummary
        @quiz={{onboardingAnswer.quiz}}
        @answer={{onboardingAnswer.answer}}
      />
    {{/each}}
  {{else}}
    <EmptyState
      @message="No onboarding answers yet. They'll appear here once your coachee submits their coaching questionnaire."
      @icon="ph:clipboard-text"
    />
  {{/if}}
</template> satisfies TOC<CoacheeOnboardingAnswersSignature>;
